var components
try {
  components = {
    uSwiper: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-swiper/u-swiper" */ "@/uni_modules/uview-ui/components/u-swiper/u-swiper.vue"
      )
    },
    uImage: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-image/u-image" */ "@/uni_modules/uview-ui/components/u-image/u-image.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-icon/u-icon" */ "@/uni_modules/uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uTag: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-tag/u-tag" */ "@/uni_modules/uview-ui/components/u-tag/u-tag.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-button/u-button" */ "@/uni_modules/uview-ui/components/u-button/u-button.vue"
      )
    },
    uTabs: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-tabs/u-tabs" */ "@/uni_modules/uview-ui/components/u-tabs/u-tabs.vue"
      )
    },
    uEmpty: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-empty/u-empty" */ "@/uni_modules/uview-ui/components/u-empty/u-empty.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = Array.isArray(_vm.classList) && _vm.classList.length > 0
  var l0 = g0
    ? _vm.__map(_vm.classList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var m0 = _vm.getImageUrl(item.course.logo)
        var m1 = _vm.secondsToHms(item.course.period)
        return {
          $orig: $orig,
          m0: m0,
          m1: m1,
        }
      })
    : null
  var g1 = _vm.examList && _vm.examList.length > 0
  var l1 = g1
    ? _vm.__map(_vm.examList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g2 = item.examPaper.deadline.substring(0, 10)
        return {
          $orig: $orig,
          g2: g2,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
        g1: g1,
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }